(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Funcionalidad del drawer del carrito
  document.addEventListener('DOMContentLoaded', function () {
    const cartButton = document.getElementById('cart-icon-bubble');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-drawer-overlay');
    const closeButton = cartDrawer.querySelector('.cart-drawer__close');

    // Aseguramos que el drawer esté oculto inicialmente y luego lo mostramos con display:block
    // pero manteniendo las clases que lo mantienen fuera de la pantalla
    setTimeout(function () {
      cartDrawer.style.display = 'block';
    }, 200);

    // Abrir el drawer
    cartButton.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      cartDrawer.setAttribute('aria-hidden', 'false');
      cartButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });

    // Cerrar el drawer (botón de cerrar)
    closeButton.addEventListener('click', function () {
      closeCartDrawer();
    });

    // Overlay solo cierra si se hace clic explícitamente
    cartOverlay.addEventListener('click', function (e) {
      closeCartDrawer();
    });

    // Evitar que los clics dentro del drawer se propaguen al overlay
    cartDrawer.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    function closeCartDrawer() {
      // Move focus to the cart button before hiding the drawer
      if (cartButton) {
        cartButton.focus();
      } else {
        document.body.focus();
      }
      
      cartDrawer.classList.remove('active');
      cartOverlay.classList.remove('active');
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      const overlay = document.querySelector('.cart-drawer__left-overlay');
      if (overlay) {
          overlay.style.transform = 'translateX(-100%)';
          overlay.style.opacity = '0';
          
          overlay.addEventListener('transitionend', function handler() {
              overlay.classList.remove('active');
              overlay.removeEventListener('transitionend', handler);
          }, { once: true });
      }
    }

    // Funcionalidad para actualizar cantidades
    const quantityInputs = document.querySelectorAll('.cart-drawer__quantity-input');
    const decreaseButtons = document.querySelectorAll('.js-quantity-decrease');
    const increaseButtons = document.querySelectorAll('.js-quantity-increase');

    // Actualizar cantidad al cambiar el input
    quantityInputs.forEach((input) => {
      input.addEventListener('change', function () {
        const itemKey = this.dataset.itemKey;
        const newQuantity = parseInt(this.value);

        updateCartItem(itemKey, newQuantity);
      });
    });

    // Disminuir cantidad
    decreaseButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const itemKey = this.dataset.itemKey;
        const input = document.querySelector(`.cart-drawer__quantity-input[data-item-key="${itemKey}"]`);
        let currentQuantity = parseInt(input.value);

        if (currentQuantity > 0) {
          currentQuantity--;
          input.value = currentQuantity;
          updateCartItem(itemKey, currentQuantity);
        }
      });
    });

    // Aumentar cantidad
    increaseButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const itemKey = this.dataset.itemKey;
        const input = document.querySelector(`.cart-drawer__quantity-input[data-item-key="${itemKey}"]`);
        let currentQuantity = parseInt(input.value);

        currentQuantity++;
        input.value = currentQuantity;
        updateCartItem(itemKey, currentQuantity);
      });
    });

    // Función para actualizar el carrito mediante fetch API
    function updateCartItem(itemKey, quantity) {
      // Añadimos una clase al body para indicar que se está actualizando el carrito
      document.body.classList.add('js-cart-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity,
        }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Recargar el drawer del carrito
          location.reload();
        })
        .catch((error) => {
          console.error('Error al actualizar el carrito:', error);
          // Eliminamos la clase incluso si hay error
          document.body.classList.remove('js-cart-updating');
        });
    }

    // Update the cart item count dynamically
    const cartItemCountElement = document.getElementById('cart-item-count');

    function updateCartItemCount() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          cartItemCountElement.textContent = cart.item_count;
        })
        .catch((error) => console.error('Error fetching cart data:', error));
    }

    // Update the count on page load
    updateCartItemCount();

    // Update the count whenever the cart is modified
    document.body.addEventListener('js-cart-updating', updateCartItemCount);
  });

  } catch(e) { console.error(e); }
})();
})();
